module.exports = __webpack_public_path__ + "static/media/i3.8ff041e5.jpg";